<template>
  <div class="col-span-6">
    <label for="field.label" class="block text-sm font-medium leading-5 text-gray-700">
      {{field.label}}
    </label>
    <div class="mt-1 relative">
      {{value}}
    </div>
  </div>
</template>
<script>
import { format, parseISO, intervalToDuration, addSeconds } from 'date-fns'
export default {
  name: 'legend-field',
  data() {
    return {
      value: ''
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    params: {
      field: {
        type: Object
      }
    },
    formdata: {
      field: {
        type: Object,
        required: true,
      }
    },
    formtype: {
      field: {
        type: String,
        required: true
      }
    }
  },

  created() {
    this.getValues()
  },

  watch: {
    formdata: {
      deep: true,
      handler: function(newVal) {
        console.log('legend formdata', newVal)
        this.getValues()
      }
    }
  },

  methods: {
    async getValues() {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'JWT ' + this.$store.getters.auth.token
        },
        params: {
          form: this.formtype,
          legend: true,
          ...this.params,
          ...this.formdata
        }
      }
      const response = await this.$http.get(this.field.uri, config)
      var payload = response.data[this.field.key]
      if (payload.renderer === 'datetime') {
        this.value = this.formatDate(payload.value)
      } else if (payload.renderer === 'timedelta') {
        this.value = this.formatDelta(payload.value)
      } else {
        this.value = payload.value
      }

    },
    formatDate(val) {
      return format(parseISO(val+'Z'), 'dd/MM/yy HH:mm:ss')
    },
    formatDelta(secs) {
      let duration = { days:0, hours:0, minutes:0, seconds:0 }
      if(secs){
        duration = intervalToDuration({
          start: new Date(),
          end: addSeconds(new Date(), secs)
        })
      }
      const zeros = data => data <= 9 ? `0${data}` : data

      if(duration.days == 1) {
        return `${duration.days} día, ${zeros(duration.hours)}:${zeros(duration.minutes)}:${zeros(duration.seconds)}`
      } else if(duration.days > 1){
        return `${duration.days} días, ${zeros(duration.hours)}:${zeros(duration.minutes)}:${zeros(duration.seconds)}`
      } else {
        return `${zeros(duration.hours)}:${zeros(duration.minutes)}:${zeros(duration.seconds)}`
      }
    },

  }
}
</script>
